import React from "react";
import { EmptyLabel } from "../label/EmptyLabel.js";
import "../label/LabelHoc.js";
import "@mui/material";
import { StyledTooltip } from "../tooltip/Tooltip.js";
import "moment-timezone";
import "react-intl";
import "../tooltip/AutoAdjustedWidthTooltip.styles.js";
import "../tooltip/AutoAdjustedComplexTooltip.styles.js";
import "../tooltip/MultiLineAutoAdjustedWidthTooltip.js";
import { SystemColorsEnum } from "../../style/types.js";
import "../../style/hooks.js";
import { CircleBoxWithText } from "./CircleBoxWithText.js";
function CircleBoxWithColorMapping({ value, label, colorMapping }) {
  return /* @__PURE__ */ React.createElement(React.Fragment, null, value ? /* @__PURE__ */ React.createElement(
    StyledTooltip,
    {
      title: label,
      element: /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(
        CircleBoxWithText,
        {
          letter: value?.charAt(0),
          color: value ? colorMapping[value] : SystemColorsEnum.DarkGrey,
          size: "small",
          text: label
        }
      ))
    }
  ) : /* @__PURE__ */ React.createElement(EmptyLabel, { defaultSymbol: "dash" }));
}
export {
  CircleBoxWithColorMapping
};
//# sourceMappingURL=CircleBoxWithColorMapping.js.map
